<template>
    <v-form ref="fileForm" @submit.prevent="onSentForm" enctype="multipart/form-data">
        <v-file-input
            ref="fileInput"
            :label="label"
            name="HousePersonDebtors"
            hint="! Важно. Загружаемый файл должен быть заполнен по шаблону"
            persistent-hint
            outlined
            required
        >
            <template v-slot:append-outer>
                <v-btn :disabled="isFetch" color="success" type="submit">Загрузить</v-btn>
            </template>
            <template v-slot:message="{message}">
                <span style="color: orange">{{message}}</span>
            </template>
        </v-file-input>
    </v-form>
</template>

<script>
import {mapActions} from 'vuex';
export default {
    name: "SocialDebtorsUploadForm",
    data(){
        return {
            isFetch: false
        }
    },
    methods:{
        ...mapActions('uploadDebtors', ['upload']),
        async onSentForm(){
            this.isFetch = true;
            try{
                const formData = new FormData(this.$refs.fileForm.$el);
                let {data} = await this.upload(formData);
                this.$emit('upload', data);
                this.$refs.fileInput.reset();
            }catch(e){
                console.log(e);
            }finally{
                this.isFetch = false;
            }

        }
    },
    computed: {
        label(){
            return 'Загрузить файл с должниками';
        }
    }
}
</script>

<style scoped>

</style>